import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface StripeInfo {
  hasStripeAccount: boolean;
  isStripeOnboarded: boolean;
}

const initialMerchantAuthState: StripeInfo = {
  hasStripeAccount: false,
  isStripeOnboarded: false,
};

export const MerchantAuthSlice = createSlice({
  name: 'merchantAuth',
  initialState: initialMerchantAuthState,
  reducers: {
    setHasStripeAccount: (state, action: PayloadAction<StripeInfo['hasStripeAccount']>) => {
      state.hasStripeAccount = action.payload;
    },
    setIsStripeOnboarded: (state, action: PayloadAction<StripeInfo['isStripeOnboarded']>) => {
      state.isStripeOnboarded = action.payload;
    },
    resetStripeDetail: (state) => {
      state.hasStripeAccount = initialMerchantAuthState.hasStripeAccount;
      state.isStripeOnboarded = initialMerchantAuthState.isStripeOnboarded;
    },
  },
});

export const { setHasStripeAccount, setIsStripeOnboarded, resetStripeDetail } = MerchantAuthSlice.actions;

export default MerchantAuthSlice.reducer;
